import script from "./SourceComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SourceComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SourceComponent.vue?vue&type=style&index=0&id=0a0e1099&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a0e1099"]])

export default __exports__